import banner7 from "../assets/banner7.jpg";
import UnifiedServicePage from "./UnifiedServicePage";

export default function SolarWaterPumpPage() {
  return (
    <UnifiedServicePage
      title="Solar Water Pumping Systems"
      kicker="Efficient Water Access with Solar Energy"
      intro="We design and install solar water pumping systems that provide reliable water delivery for communities, agriculture, and institutional use."
      heroImage={banner7}
      overviewTitle="Reliable Pumping for Critical Needs"
      overviewText="Our systems are engineered for dependable flow, low operating cost, and strong performance in remote and off-grid locations."
      featureTitle="What We Deliver"
      features={[
        {
          title: "Site Assessment & Sizing",
          desc: "Water source analysis, head calculation, and system sizing for required output.",
        },
        {
          title: "Solar Pump Installation",
          desc: "Professional setup of pumps, controllers, and solar arrays for consistent operation.",
        },
        {
          title: "Storage & Distribution",
          desc: "Tank and pipeline integration to support stable supply and pressure management.",
        },
        {
          title: "Agricultural Applications",
          desc: "Irrigation-oriented pumping systems designed for farm productivity and efficiency.",
        },
        {
          title: "Community Water Supply",
          desc: "Rural and institutional delivery for schools, health facilities, and settlements.",
        },
        {
          title: "After-Sales Service",
          desc: "Maintenance support and troubleshooting for long-term pump reliability.",
        },
      ]}
      focusTitle="Delivery Lifecycle"
      focusItems={[
        {
          title: "Assessment",
          desc: "Technical survey of source, distance, and required pumping capacity.",
        },
        {
          title: "Design",
          desc: "System design optimized for daily usage patterns and seasonal demand.",
        },
        {
          title: "Implementation",
          desc: "Installation, commissioning, and user orientation by our field teams.",
        },
        {
          title: "Support",
          desc: "Ongoing service plans to sustain system performance over time.",
        },
      ]}
      testimonyQuote="The installed solar pumping system has improved reliability and reduced our running costs significantly."
      testimonyAuthor="Operations Coordinator"
      ctaTitle="Need a Solar Pumping Solution?"
      ctaText="Talk to us about your water demand and we will propose a system that fits your site."
    />
  );
}
